import { rewardsAuthApiClientV3Token } from "@apps/rewards/tokens";
import { JsonMimeType } from "@lib/ApiClient";
import type ApiClientInterface from "@lib/ApiClient/ApiClientInterface";
import type { Observable } from "rxjs";
import { map } from "rxjs";
import { create } from "superstruct";
import { inject, singleton } from "tsyringe";

import type {
    RewardsSpendingRulesRedeemEntity,
    RewardsSpendingRulesResponse,
} from "../models/RewardsSpendingRulesEntities";
import { RewardsSpendingRulesRedeemSchema } from "../models/RewardsSpendingRulesRedeemSchema";
import { RewardsSpendingRulesRefundEntity } from "../models/RewardsSpendingRulesRefundEntity";
import { RewardsSpendingRulesRefundSchema } from "../models/RewardsSpendingRulesRefundSchema";
import { RewardsSpendingRulesResponseSchema } from "../models/RewardsSpendingRulesSchema";
import type {
    RewardsSpendingRulesQueryParams,
    RewardsSpendingRulesRedeemBody,
    RewardsSpendingRulesRefundBody,
} from "../types";

@singleton()
class RewardsSpendingRulesApiService {
    constructor(
        @inject(rewardsAuthApiClientV3Token)
        private readonly apiClientV3: ApiClientInterface
    ) {}

    getSpendingRules(
        queryParams: RewardsSpendingRulesQueryParams
    ): Observable<RewardsSpendingRulesResponse> {
        return this.apiClientV3
            .get({
                url: "/spends/getSpendingRules",
                responseType: "json",
                queryParams,
            })
            .pipe(
                map((response) =>
                    create(response.body, RewardsSpendingRulesResponseSchema)
                )
            );
    }

    redeem(
        body: RewardsSpendingRulesRedeemBody
    ): Observable<RewardsSpendingRulesRedeemEntity> {
        return this.apiClientV3
            .post({
                url: "/spends/redeemReward",
                body: JSON.stringify(body),
                responseType: "json",
                contentType: JsonMimeType,
            })
            .pipe(
                map((response) =>
                    create(response.body, RewardsSpendingRulesRedeemSchema)
                )
            );
    }

    refund(
        body: RewardsSpendingRulesRefundBody
    ): Observable<RewardsSpendingRulesRefundEntity> {
        return this.apiClientV3
            .post({
                url: "/spends/refundReward",
                body: JSON.stringify(body),
                responseType: "json",
                contentType: JsonMimeType,
            })
            .pipe(
                map((response) =>
                    create(response.body, RewardsSpendingRulesRefundSchema)
                )
            );
    }
}

export default RewardsSpendingRulesApiService;
